export default __webpack_public_path__ + "media/images/pause-ec610f6b8efc6a47c961cc3cfbc7d7d0.svg";